import {
  GET_GROWOP_LIST,
  GET_GROWOP_LIST_COMPLETED,
  GET_GROWOP_LIST_FAILED,
  SELECT_GROWOP
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";

const defaultState = {
  growOpList: [],
  growOpListLoading: false,
  growOpListError: null,
  selectedGrowOpId: '',
};

function growOpReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_GROWOP_LIST: {
      return {
        ...state,
        growOpListLoading: true,
        growOpList: [],
        growOpListError: null,
      };
    }
    case GET_GROWOP_LIST_COMPLETED: {
      return {
        ...state,
        growOpListLoading: false,
        growOpList: action.payload.data,
      };
    }
    case GET_GROWOP_LIST_FAILED: {
      return {
        ...state,
        growOpListLoading: false,
        growOpListError: action.payload,
      };
    }
    case SELECT_GROWOP: {
      const {growOpId} = action.payload;
      return {
        ...state,
        selectedGrowOpId: growOpId,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
}

export default growOpReducer;



// WEBPACK FOOTER //
// ./src/GrowOp/reducer.js